(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/onboarding-theme/assets/onboarding-theme.js') >= 0) return;  svs.modules.push('/components/accountservices/onboarding-theme/assets/onboarding-theme.js');
'use strict';

const isServer = typeof exports === 'object';
const allowedBrandings = {
  EUROJACKPOT: 'eurojackpot',
  TRISS: 'triss',
  LOTTO: 'lotto',
  KENO: 'keno',
  VIKINGLOTTO: 'vikinglotto',
  SUPPORTERN: 'supportern'
};
const inverted = {
  EUROJACKPOT: true,
  TRISS: false,
  LOTTO: true,
  KENO: false,
  VIKINGLOTTO: true,
  SUPPORTERN: true
};
const accentColor = {
  SUPPORTERN: 'bg-supportern-200',
  TUR: 'bg-tur-200'
};

const getAccentColor = function () {
  var _accentColor$game;
  let game = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'TUR';
  return (_accentColor$game = accentColor[game]) !== null && _accentColor$game !== void 0 ? _accentColor$game : "bg-".concat(game, "-100").toLowerCase();
};

const getInverted = game => {
  var _inverted$game;
  return (_inverted$game = inverted[game]) !== null && _inverted$game !== void 0 ? _inverted$game : false;
};

const getFontColor = isInverted => isInverted ? 'f-inverted' : 'fc-navy';

const getTheme = branding => {
  var _branding$toUpperCase, _allowedBranding$toUp;
  const allowedBranding = allowedBrandings[branding === null || branding === void 0 || (_branding$toUpperCase = branding.toUpperCase) === null || _branding$toUpperCase === void 0 ? void 0 : _branding$toUpperCase.call(branding)];
  const allowedBrandingUpper = allowedBranding === null || allowedBranding === void 0 || (_allowedBranding$toUp = allowedBranding.toUpperCase) === null || _allowedBranding$toUp === void 0 ? void 0 : _allowedBranding$toUp.call(allowedBranding);
  return {
    branding: allowedBranding,
    fontColor: getFontColor(getInverted(allowedBrandingUpper)),
    product: allowedBranding,
    isInverted: getInverted(allowedBrandingUpper),
    accentColor: getAccentColor(allowedBrandingUpper)
  };
};
if (isServer) {
  module.exports = {
    getTheme
  };
} else {
  svs.accountservices.onboardingTheme = {
    getTheme
  };
}

 })(window);